module.exports = __webpack_public_path__ + "static/img/pad10.a567cb55.png";